import { render, staticRenderFns } from "./ShortLangPicker.vue?vue&type=template&id=32647e2e&scoped=true&"
import script from "./ShortLangPicker.vue?vue&type=script&lang=js&"
export * from "./ShortLangPicker.vue?vue&type=script&lang=js&"
import style0 from "./ShortLangPicker.vue?vue&type=style&index=0&id=32647e2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32647e2e",
  null
  
)

export default component.exports